<div class="col-12">
  <div class="table-responsive">
    <table class="table table-sm align-middle">
      <thead>
        <tr>
          <th style="width: 90px">Ordem</th>
          <th>Tipo</th>
          <th>Horario</th>
          <th>Tol. antes</th>
          <th>Tol. depois</th>
          <th>Ativo</th>
          <th class="text-end">Acao</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let horario of jornada.horarios; let indice = index">
          <td>
            <input
              class="form-control form-control-sm"
              type="number"
              min="1"
              name="sequenciaJornada{{ indice }}"
              [(ngModel)]="horario.sequencia"
              (ngModelChange)="emitirJornada()">
          </td>
          <td>
            <select
              class="form-select form-select-sm"
              name="tipoJornada{{ indice }}"
              [(ngModel)]="horario.tipo"
              (ngModelChange)="emitirJornada()">
              <option value="ENTRADA">Entrada</option>
              <option value="SAIDA">Saida</option>
            </select>
          </td>
          <td>
            <input
              class="form-control form-control-sm"
              type="time"
              name="horarioJornada{{ indice }}"
              [(ngModel)]="horario.horario"
              (ngModelChange)="emitirJornada()"
              required>
          </td>
          <td>
            <input
              class="form-control form-control-sm"
              type="number"
              min="0"
              max="120"
              name="tolAntesJornada{{ indice }}"
              [(ngModel)]="horario.toleranciaAntesMinutos"
              (ngModelChange)="emitirJornada()"
              [disabled]="!jornada.validarJanelaPonto">
          </td>
          <td>
            <input
              class="form-control form-control-sm"
              type="number"
              min="0"
              max="120"
              name="tolDepoisJornada{{ indice }}"
              [(ngModel)]="horario.toleranciaDepoisMinutos"
              (ngModelChange)="emitirJornada()"
              [disabled]="!jornada.validarJanelaPonto">
          </td>
          <td>
            <input
              class="form-check-input"
              type="checkbox"
              name="ativoHorarioJornada{{ indice }}"
              [(ngModel)]="horario.ativo"
              (ngModelChange)="emitirJornada()">
          </td>
          <td class="text-end">
            <button
              type="button"
              class="btn btn-outline-danger btn-sm"
              [disabled]="jornada.horarios.length <= 1"
              (click)="removerHorario.emit(indice)">
              <i class="bi bi-trash"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <button type="button" class="btn btn-outline-primary btn-sm" (click)="adicionarHorario.emit()">
    <i class="bi bi-plus-lg px-1"></i>Adicionar horario
  </button>
</div>
